/**
 * Entity types used throughout the content management system
 */
export enum EntityType {
  COMMUNITY = 'community',
  COMMUNITY_GROUP = 'communityGroup',
}
